import React from "react";
import { requiredUrl } from "../../../util/validation";
import { Text } from "../../../../common/components/input/Text";
import { Adornment } from "../../input/Adornment";
import { Form } from "react-final-form";
import { Button } from "@mui/material";

type TrueScanScannerProps = {
  onStartScan: (url: string) => void;
  inProgress: boolean;
  suggestedUrl?: string | null;
};

export const TrueScanScanner = ({
  onStartScan,
  inProgress,
  suggestedUrl = "",
}: TrueScanScannerProps) => {
  const handleUrlSubmit = async (values: any) => {
    onStartScan(values.websiteUrl);
  };

  const validate = (values: any) => {
    const errors = {} as { [x: string]: string };
    requiredUrl(values, "websiteUrl", errors);
    return errors;
  };

  return (
    <>
      <p>
        Scan your website with TrueScan to detect new scripts, verify your website setup, and ensure
        consent requirements are being respected.
      </p>
      <Form
        onSubmit={handleUrlSubmit}
        validate={validate}
        render={({ handleSubmit, valid, form }) => {
          const formApi = form; // Access formApi here
          const textInput = (
            <Text
              multiline={false}
              variant="outlined"
              field="websiteUrl"
              initialValue={(suggestedUrl ?? "").replace(/^https?:\/\//i, "")}
              className="mr-md mt-0"
              fullWidth
              InputProps={{
                startAdornment: <Adornment position="start">https://</Adornment>,
              }}
              size="medium"
              required
              disabled={inProgress}
              onChange={(event) => {
                const inputValue = event.target.value;
                const cleanedValue = inputValue.replace(/^https?:\/\//i, "");
                formApi.change("websiteUrl", cleanedValue); // Use formApi.change
              }}
            />
          );

          return (
            <form
              className="d-flex align-items-start mb-xl"
              onSubmit={handleSubmit}
              style={{ width: "945px", marginTop: "24px" }}
            >
              {textInput}

              <Button
                size="large"
                color="primary"
                type="submit"
                variant="contained"
                disabled={!valid || inProgress}
                style={{ height: "60px", padding: "0 25px" }}
              >
                {inProgress ? "Scanning..." : "Run TrueScan"}
              </Button>
            </form>
          );
        }}
      ></Form>
    </>
  );
};
